//State
import {LOGIN} from '../utility/constants'
export default function(state=null,action){
  switch (action.type) {
    case LOGIN:
        return action.payload;
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducer/login.js